import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lang:null,
    texts:{},
    direction:'rtl'
}

const translateSlice = createSlice({
    name: "translate",
    initialState,
    reducers: {
        init(state, action) {
            state.lang =  action.payload.lang;
            state.texts = action.payload.texts;
            state.direction = action.payload.direction;
        }
    }
})

export const translateActions = translateSlice.actions;
export default translateSlice
